import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Select } from "antd";
/**
 * Select Filter Item Component
 * Generic selector that works with any options — supports both multi- and single-select.
 * Designed to work with the unified filter architecture.
 */
const SelectFilterItem = ({ name, options = [], value, onChange, label = "Статус", placeholder = "Выберите статусы", allowClear = true, style, mode = "multiple", testId, }) => {
    return (_jsxs("div", { children: [label && (_jsxs("label", { style: {
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#595959",
                    marginBottom: "4px",
                    display: "block",
                }, children: [label, ":"] })), _jsx(Select, { options: options, mode: mode === "multiple" ? "multiple" : undefined, placeholder: placeholder, style: { width: "100%", ...style }, value: value ?? (mode === "multiple" ? [] : undefined), allowClear: allowClear, onChange: onChange, "data-filter-name": name, "data-filter-type": mode === "multiple" ? "multiSelect" : "singleSelect", "data-testid": testId })] }));
};
export default SelectFilterItem;
